export default __webpack_public_path__ + "static/icon-spin-the-wheel-b2aa577244bfba8b72f079947165f7b0.png";